export const MAX_DOCX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const DOCX_FILE_EXTENSION = '.docx';
